import React, { Component } from 'react'
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import Button from '@material-ui/core/Button';
import MuiLink from '@material-ui/core/Link';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import LocationOn from '@material-ui/icons/LocationOn';
import LinkIcon from '@material-ui/icons/Link';
import CalendarToday from '@material-ui/icons/CalendarToday';
import dayjs from 'dayjs';
import EditIcon from '@material-ui/icons/Edit';
import KeyboardReturn from '@material-ui/icons/KeyboardReturn';
import MyButton from '../../util/myButton';

import ProfileSkeleton from '../../util/ProfileSkeleton';


import EditDetails from './EditDetails';
//redux
import { logoutUser, uploadImage } from '../../redux/actions/userActions';

const Link = require('react-router-dom').Link;

const styles = (theme) => ({
    ...theme.spread
});

export class Profile extends Component {
    handleImageChange = (event) => {
        const image = event.target.files[0];
        //send to server 
        const formData = new FormData();
        formData.append('image', image, image.name);
        this.props.uploadImage(formData);
    };

    handleEditPicture = () => {
        const fileInput = document.getElementById('imageUpload');
        fileInput.click();

    }

    handleLogout = () => {
        this.props.logoutUser();
    }
    render() {
        const { classes, user: { credentials: { handle, createdAt, imgUrl, bio, website, location }, loading, authenticated } } = this.props;
        let profileMarkup = !loading ? (authenticated ? (<Paper className={classes.paper}>
            <div className={classes.profile}>
                <div className='image-wrapper'>
                    <img src={imgUrl} alt='profile' className='profile-image' />
                    <input hidden='hidden' id='imageUpload' type='file' onChange={this.handleImageChange} />

                    <MyButton tip='Upload profile picture' onClick={this.handleEditPicture} btnClassName='button' >
                        <EditIcon color='primary' />

                    </MyButton>
                </div>
                <hr />
                <div className='profile-details'>
                    <MuiLink component={Link} to={`/users/${handle}`} color='primary' variant='h5' >
                        @{handle}

                    </MuiLink>
                    <hr />
                    {bio && <Typography variant='body2'>{bio}</Typography>}
                    <hr />
                    {location && (
                        <React.Fragment>
                            <LocationOn color='primary' /> <span>{location}</span> <hr />
                        </React.Fragment>)}
                    {website && (
                        <React.Fragment>
                            <LinkIcon color='primary' />
                            <a href={website} target='_blank' rel='noopener noreferrer'>
                                {' '}{website}
                            </a>
                            <hr />
                        </React.Fragment>
                    )}
                    <CalendarToday color='primary' />{' '}
                    <span>Joined {dayjs(createdAt).format('MMM YYYY')}</span>
                </div>

                <MyButton tip='Logout' onClick={this.handleLogout} >
                    <KeyboardReturn color='primary' />

                </MyButton>
                <EditDetails />
            </div>
        </Paper>)
            : (
                <Paper className={classes.paper}>
                    <Typography variant='body2' align='center'>
                        No profile found, please login again!
                    </Typography>
                    <div className={classes.buttons}>
                        <Button variant='contained' color='primary' component={Link} to='/login'>Login</Button>
                        <Button variant='contained' color='secondary' component={Link} to='/signup'>Signup</Button>
                    </div>
                </Paper>
            )) : (<ProfileSkeleton />)

        return profileMarkup;
    }
}

const mapStateToProps = (state) => ({
    user: state.user
});

const mapActionsToProps = {
    logoutUser,
    uploadImage
}

Profile.propTypes = {
    user: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    logoutUser: PropTypes.func.isRequired,
    uploadImage: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapActionsToProps)(withStyles(styles)(Profile));
